import { render } from "./PurchasePaymentReport.vue?vue&type=template&id=c837f7c8"
import script from "./PurchasePaymentReport.vue?vue&type=script&lang=js"
export * from "./PurchasePaymentReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__